@if (invoice && petData) {
  <cpf-invoice-details [invoice]="invoice" [petData]="petData"></cpf-invoice-details>
}
